import { render, staticRenderFns } from "./ScrmOrder.vue?vue&type=template&id=13a51a1e&"
import script from "./ScrmOrder.vue?vue&type=script&lang=js&"
export * from "./ScrmOrder.vue?vue&type=script&lang=js&"
import style0 from "./ScrmOrder.vue?vue&type=style&index=0&id=13a51a1e&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports